import React from "react";
import { RouteComponentProps } from "react-router";
import ChangePassword from "./ChangePassword";

const ActivateAccount: React.FC<RouteComponentProps> = (props) => {
    return <ChangePassword {...props} isActivateAccount />;
};

export default ActivateAccount;
